import React from 'react';
import HeaderText from '../../Common/HeaderText';

const MyMvpsHeader = ({ mvpsList, onSeeAll }) => {
  return (
    <div className='flex flex-col w-full items-start'>
      <HeaderText label={'My MVPs'} mvpsList={mvpsList} onSeeAll={onSeeAll} />
    </div>
  );
};

export default MyMvpsHeader;
